import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../../../shared/auth/auth.service';
import { UserStoreService } from '../../../../../shared/services/user-store.service';
import { DropdownComponent } from '../../../../../shared/components/ui/dropdown/dropdown.component';
import { DropdownItemTwoComponent } from '../../../../../shared/components/ui/dropdown/dropdown-item/dropdown-item.component-two';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports:[CommonModule,RouterModule,DropdownComponent,DropdownItemTwoComponent]
})
export class UserDropdownComponent {
  isOpen = false;

  constructor(
    private authService: AuthService,
    public userStore: UserStoreService) {}

  get initials(): string {
    const initials = (this.userStore.firstName().charAt(0) + this.userStore.lastName().charAt(0)).toUpperCase();
    return initials || '?';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }


  signOut(): void {
    this.authService.logout();
  }
}